@charset "UTF-8";

/* src/app/pages/project/map/repository/import-wizard/components/geospatial/step3-validation_confirm/import-wizard-geospatial-confirmation_validation.component.scss */
:host {
  display: flex;
  flex-direction: column;
  flex: 1;
  min-height: 0;
  padding: 16px;
}
.confirmation-validation-container {
  display: grid;
  grid-template-columns: repeat(7, 1fr);
  grid-template-rows: 1fr;
  gap: 1rem;
  flex: 1;
  min-height: 0;
}
.preview-map-container {
  border: 1px solid #333;
  border-radius: 12px;
  height: 45%;
  overflow: hidden;
}
.columns-mapping-container {
  display: flex;
  flex-direction: column;
  gap: 0.7rem;
  grid-column: span 3;
  border: 1px solid #333;
  border-radius: 12px;
  flex: 1;
  padding: 0.5rem 1rem;
  overflow-x: hidden;
  overflow-y: hidden;
}
.preview-tabular-container {
  display: flex;
  flex-direction: column;
  grid-column: span 4;
  height: 100%;
  overflow-y: auto;
  overflow-x: hidden;
}
.feature-item {
  padding: 0.5rem;
  border-bottom: 1px solid #ddd;
}
.feature-list {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}
.errors-wrapper {
  display: flex;
  flex-direction: column;
  position: relative;
  border: 1px solid rgb(51, 51, 51);
  border-radius: 10px;
  overflow-x: hidden;
  overflow-y: hidden;
  padding: 0.7rem;
  flex: 1;
}
.errors-wrapper > h6 {
  margin-bottom: 0.3rem;
  font-size: 15px;
}
.search-input-dimension {
  margin-bottom: 12px;
  max-width: 450px;
}
.button-container {
  display: flex;
  justify-content: flex-end;
  gap: 1rem;
  grid-column: span 7;
  align-self: end;
  height: fit-content;
  margin-top: 1rem;
}
.button-container > button {
  background: #FACC15;
  color: #2a2a2a;
  border: none;
  border-radius: 6px;
  padding: 8px 24px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  width: fit-content;
  height: fit-content;
  transition: all 0.2s ease;
}
.button-container > button:hover {
  background: #FACC15;
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(255, 215, 0, 0.3);
}
.button-container > button:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}
.button-container > button:active {
  transform: translateY(0);
}
.button-container > button.secondary {
  background: #444444;
  color: #ffffff;
}
.button-container > button.secondary:hover {
  background: #3d3d3d;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.3);
}
.validation-errors {
  display: flex;
  flex-direction: column;
  gap: 16px;
  flex: 1;
  overflow-y: auto;
}
.error-group {
  opacity: 0;
  transform: translateY(12px);
  animation: fadeCascade 320ms ease forwards;
  background: #111111;
  border: 1px solid #1f1f1f;
  border-radius: 12px;
  padding: 16px;
  display: flex;
  flex-direction: column;
  gap: 10px;
  transition: all 0.2s ease;
}
.error-group.invalid-file-group {
  background: transparent;
  border: none;
  box-shadow: none;
  padding: 0;
  flex: 1;
}
.error-group:hover:not(.invalid-file-group) {
  border-color: #2b2b2b;
  background: #141414;
}
.error-group-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 14px;
}
.error-title {
  display: flex;
  flex-direction: column;
  gap: 2px;
}
.error-column {
  font-size: 15px;
  font-weight: 700;
  color: #ffffff;
}
.error-column.invalid-file {
  color: #f05d5d;
}
.error-count {
  font-size: 12px;
  color: #9ca3af;
}
.error-type-badge {
  font-size: 12px;
  color: #facc15;
  background: rgba(250, 204, 21, 0.08);
  border: 1px solid rgba(250, 204, 21, 0.2);
  padding: 4px 10px;
  border-radius: 999px;
  font-weight: 600;
  white-space: nowrap;
}
.error-description {
  font-size: 13px;
  color: #bdbdbd;
}
.error-rows {
  display: flex;
  flex-direction: column;
  gap: 6px;
}
.error-row-item {
  display: flex;
  align-items: center;
  gap: 10px;
  background: #171717;
  border: 1px solid #262626;
  border-radius: 8px;
  padding: 6px 10px;
  font-size: 13px;
}
.row-number {
  font-weight: 700;
  color: #f87171;
  min-width: 70px;
}
.row-value {
  color: #e5e7eb;
  font-family: monospace;
  background: #0f0f0f;
  border-radius: 6px;
  padding: 2px 6px;
}
.no-errors-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
  text-align: center;
  gap: 10px;
  animation: fadeCascade 320ms ease forwards;
}
.status-icon,
.error-icon,
.success-icon {
  font-family: "Material Icons";
  font-size: 48px;
  width: 72px;
  height: 72px;
  border-radius: 999px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.success-icon {
  color: #22c55e;
  background: rgba(34, 197, 94, 0.08);
  border: 1px solid rgba(34, 197, 94, 0.25);
}
.error-icon {
  color: #ef4444;
  background: rgba(239, 68, 68, 0.08);
  border: 1px solid rgba(239, 68, 68, 0.25);
}
.success-title {
  font-size: 18px;
  font-weight: 700;
  color: #ffffff;
}
.success-description {
  font-size: 14px;
  color: #9ca3af;
  max-width: 420px;
}
.mat-mdc-table {
  background: transparent !important;
}
.mat-mdc-header-row,
.mat-mdc-header-cell {
  background: rgb(51, 51, 51) !important;
  border-bottom: 1px solid rgba(255, 255, 255, 0.2);
  color: white;
}
.mat-mdc-row,
.mat-mdc-cell {
  background: transparent !important;
  color: white;
}
.mat-mdc-row:hover {
  background: rgba(255, 255, 255, 0.04) !important;
}
.mat-elevation-z8 {
  box-shadow: none !important;
}
.mat-mdc-cell {
  border-bottom: 1px solid rgba(255, 255, 255, 0.15);
}
.mat-mdc-row:last-child .mat-mdc-cell {
  border-bottom: none;
}
.mat-mdc-paginator {
  background: transparent;
  color: white !important;
  border-top: 1px solid rgba(255, 255, 255, 0.2);
}
.mat-mdc-paginator .mat-mdc-icon-button,
.mat-mdc-paginator .mat-mdc-select-value {
  color: white;
}
:host ::ng-deep .mat-mdc-paginator-icon {
  fill: white !important;
}
::ng-deep .html-content table {
  background: none !important;
  border-collapse: collapse !important;
  width: 100% !important;
}
::ng-deep .html-content tr,
::ng-deep .html-content td {
  background: none !important;
  padding: 8px !important;
  border: 1px solid #ddd !important;
}
::ng-deep .html-content tr:nth-child(even) {
  background: none !important;
}
::ng-deep .html-content tr[style*=background] {
  background: none !important;
}
::ng-deep .html-content td[bgcolor],
::ng-deep .html-content tr[bgcolor] {
  background: none !important;
}
.pending-list-progress-bar {
  position: absolute;
  top: 0;
  left: 0;
  margin: auto;
}
.pending-list-progress-bar {
  --mdc-linear-progress-active-indicator-color: var(--primary);
}
.pending-list-progress-bar {
  --mdc-linear-progress-active-indicator-height: 10px;
}
.pending-list-progress-bar {
  --mdc-linear-progress-track-color: #505050;
}
.pending-list-progress-bar {
  --mdc-linear-progress-track-height: 10px;
}
ul {
  list-style-type: none;
  padding: 0;
  margin: 0;
  display: flex;
  flex-direction: column;
  gap: 0.7rem;
  flex: 1;
  overflow-y: auto;
  overflow-x: hidden;
}
ul > li {
  display: grid;
  grid-template-columns: 4fr 1fr;
  gap: 0.5rem;
  align-items: center;
}
ul > li > span {
  font-size: 15px;
}
span.label-title {
  font-size: 15px;
  font-weight: 600;
  color: #999;
}
/*# sourceMappingURL=import-wizard-geospatial-confirmation_validation.component-GHKYGRYG.css.map */
